export enum EPossiblesLegends {
    Conectada = 1,
    ErrorDeCredenciales = 2,
    ErrorDeFormato = 3,
}